import {Component, Input} from '@angular/core';
import {ModelProvider} from "../../../providers/modelProvider/ModelProvider";
import {ModelToolsProvider} from "../../../providers/model-tools/model-tools";

@Component({
    selector: 'app-api-table',
    templateUrl: './api-table.component.html',
    styleUrls: ['./api-table.component.css']
})
export class ApiTableComponent {

    @Input()
    public title;

    @Input()
    public header;

    @Input()
    public header_translate;

    @Input()
    public data;
    @Input()
    public topData;
    @Input()
    public summary;

    showLoading = false;

    constructor(private modelProvider:ModelProvider, public tools: ModelToolsProvider) {
    }

    ngOnInit() {
        console.log("this.topData:");
        console.log(this.topData);
        console.log(this.summary);
    }

    openRow(model)
    {
        if (!model || !model['click']) {
            console.log('no click.');
            return;
        }

        this.showLoading = true;
        let filters = model['filters'];
        filters['setPrefix'] = true;
        this.modelProvider.custom('apiInvoiceDetails', filters).then((res) => {
            if (!res) return
            this.tools.showModal(ApiTableComponent, res, 'animated-popover full-size-modal');
            this.showLoading = false;
            // this.loadingScreen.dismiss();
        })
    }

}
